export const name = 'sitePagesService' as const
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/site-service-pages'
